import Head from 'next/head'
import Link from 'next/link'

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'https://erkelenz-autoverwertung.de';
const BASE_URL_WWW = process.env.NEXT_PUBLIC_BASE_URL_WITH_WWW || 'https://www.erkelenz-autoverwertung.de';
const PHONE = process.env.NEXT_PUBLIC_PHONE_NUMBER || '+49 16323 37268';

export default function About() {
  const city = "Erkelenz";
  return (
    <>
      <Head>
        <title>Über uns | Autoverwertung {city}</title>
        <meta name="description" content={`Erfahren Sie mehr über unser Team, unsere Werte und unsere Mission für nachhaltige Autoverwertung und KFZ-Ankauf in ${city}.`} />
        <meta property="og:title" content={`Über uns | Autoverwertung ${city}`} />
        <meta property="og:description" content={`Erfahren Sie mehr über unser Team, unsere Werte und unsere Mission für nachhaltige Autoverwertung und KFZ-Ankauf in ${city}.`} />
        <meta property="og:image" content="/images/cars/hero.webp" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${BASE_URL}/impressum`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`Über uns | Autoverwertung ${city}`} />
        <meta name="twitter:description" content={`Erfahren Sie mehr über unser Team, unsere Werte und unsere Mission für nachhaltige Autoverwertung und KFZ-Ankauf in ${city}.`} />
        <meta name="twitter:image" content="/logo.jpeg" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${BASE_URL_WWW}/impressum`} />
        {/* Schema.org LocalBusiness LD+JSON */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": `Autoverwertung ${city}`,
              "image": "/images/cars/hero.webp",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Laubenhof 9",
                "addressLocality": city ,
                "postalCode": "45326",
                "addressCountry": "DE"
              },
              "telephone": PHONE,
              "email": `${process.env.NEXT_PUBLIC_EMAIL_URL}`,
              "url": `${BASE_URL}/impressum`,
              "description": "Erfahren Sie mehr über unser Team, unsere Werte und unsere Mission für nachhaltige Autoverwertung und KFZ-Ankauf in Deutschland."
            })
          }}
        />
      </Head>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-primary-dark">Über uns</h1>
        <p className="mt-4 text-primary">Autoverwertung Erkelenz & Autoentsorgung | Schnell & Fachgerecht. Zurück zur <Link href="/" className="text-primary hover:underline">Startseite</Link>.</p>

        {/* Impressum Section */}
        <section className="mt-12 bg-white border border-primary-light rounded-2xl shadow-lg p-6 md:p-10 max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold mb-4 text-primary">Impressum</h2>
          <div className="space-y-4 text-primary-dark text-base">
            <div>
              <strong>Angaben gemäß § 5 TMG</strong><br />
              Joseph Dina<br />
              Laubenhof 9<br />
              45326 {city}<br />
              Telefon: <a href={`tel:${PHONE}`} className="text-primary hover:underline">{PHONE}</a>
              <br />
              E-Mail: <a href={`mailto:${process.env.NEXT_PUBLIC_EMAIL_URL}`} className="text-primary hover:underline">{process.env.NEXT_PUBLIC_EMAIL_URL}</a>
            </div>
            <div>
              <strong>EU-Streitschlichtung</strong><br />
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://ec.europa.eu/consumers/odr</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </div>
            <div>
              <strong>Verbraucher­streit­beilegung/Universalschlichtungsstelle</strong><br />
              Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil. Zuständig ist die Universalschlichtungsstelle des Zentrums für Schlichtung e.V., Straßburger Straße 8, 77694 Kehl am Rhein (<a href="https://www.verbraucher-schlichter.de" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://www.verbraucher-schlichter.de</a>).
            </div>
            <div>
              <strong>Haftung für Inhalte</strong><br />
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine Haftung ist erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </div>
            <div>
              <strong>Haftung für Links</strong><br />
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </div>
            <div>
              <strong>Urheberrecht</strong><br />
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
